export const DASHBOARD = "/admin";
export const USER_LIST = '/admin/users';
export const ROLES_LIST = '/admin/roles';
export const COMPANY_LIST = '/admin/companies';
export const USER_PROFILE = '/admin/profile';
export const OTP = '/otp';
export const REGISTER = '/register';
export const FORGOT_PASSWORD = '/reset-password';
export const ANALYTICS = '/admin/analytics'
export const CLAIMS = '/admin/claims'
export const MASTER_MANAGEMENT = '/admin/master-management'
export const CLAIMS_OVERVIEW = `/admin/claims/overview`
export const FINANCIALS = '/admin/financials'
export const FINALIZEFINANCIAL = '/admin/financials/finalizereport'
export const TECHNICALS = '/admin/technicals'
export const TERMS_AND_CONDITIONS = '/terms-and-conditions'
